<template>
    <div class="dynamic-panels">
        <div class="dyna-header">
            <div class="username">{{ username }}</div>
            <div class="date">{{ curDate }}</div>
            <div class="time">{{ curTime }}</div>
        </div>
        <div class="dyna-contents">
            <component v-bind:is="currentPanelComponent" />
        </div>
        <div class="dyna-footer">
            <img src="@/assets/images/ida-grey.png" alt="iDAvatars" width="120px" v-if="currentPanel != 'Intro'">
        </div>
    </div>
</template>

<script>
    // @ is an alias to /src
    import Intro_panel from '@/components/panels/Intro_panel.vue'
    import Vitals_panel from '@/components/panels/Vitals_panel.vue'
    import Meds_panel from '@/components/panels/Meds_panel.vue'
    import QA_panel from '@/components/panels/QA_panel.vue'

    export default {
        name: 'DynamicPanels',
        mounted: function() {
            var self = this;
            vidbaby.$(document).on('na-response.vidbaby', (event, data) => {
                switch(data.customView) {
                    case 'ShowConclusion':
                        this.switchToPanel('Intro');
                        break;
                    case 'GetTemp':
                    case 'GetPressure':
                    case 'GetOxygen':
                    case 'GetPulse':
                        this.switchToPanel('Vitals');
                        break;
                    case 'ShowMedications':
                        this.switchToPanel('Meds');
                        break;
                    default:
                        //do nothing
                }
            });
        },
        data: function() {
            return {
                currentPanel: 'Intro'
            };
        },
        computed: {
            currentPanelComponent: function() {
                return this.currentPanel + '_panel';
            }
        },
        props: [
            "username",
            "curDate",
            "curTime"
        ],
        methods: {
            switchToPanel: function(panel) {
                this.currentPanel = panel;
            }
        },
        components: {
            Intro_panel,
            Vitals_panel,
            Meds_panel,
            QA_panel
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="stylus">
.dynamic-panels
    display: flex
    flex-direction: column
    height: 100%
    width: 100%
    overflow: hidden
    background: rgba(250,250,250, 0.5)
    border-radius: 2em
    .dyna-header
        padding: 0.75em 2em
        text-align: left
        line-height: 1.25em
        font-weight: bold
    .dyna-contents
        flex: 1
        color: #333
        text-align: left
    .dyna-footer
        text-align: left
        padding: 0.75em 3.5em
</style>
